<p-toast position="top-center" [life]="3000"></p-toast>

<div class="modal-overlay" (click)="onClose()">
  <div class="modal-card" (click)="$event.stopPropagation()">

    <button class="btn-close" (click)="onClose()">✕</button>

    <div class="modal-header">
      <h2 *ngIf="currentView === 'login'">Bienvenido</h2>
      <h2 *ngIf="currentView === 'register'">Crear Cuenta</h2>
      <h2 *ngIf="currentView === 'forgot-email'">Recuperar Cuenta</h2>
      <h2 *ngIf="currentView === 'verify-code'">Verificar Código</h2>
      <h2 *ngIf="currentView === 'reset-password'">Nueva Contraseña</h2>

      <p *ngIf="currentView === 'login'">Ingresa a tu cuenta de Moanani</p>
      <p *ngIf="currentView === 'register' && !inviteLocked">Únete a nuestra comunidad</p>
      <p *ngIf="currentView === 'register' && inviteLocked">{{ inviteHint }}</p>
      <p *ngIf="currentView === 'forgot-email'">Ingresa tu email para buscar tu cuenta</p>
      <p *ngIf="currentView === 'verify-code'">Ingresa el código enviado a {{ emailForRecovery }}</p>
      <p *ngIf="currentView === 'reset-password'">Crea una nueva contraseña segura</p>
    </div>

    <div *ngIf="currentView === 'login'" class="form-container fade-in">
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-group">
          <label>Usuario</label>
          <input type="text" formControlName="username" class="form-control"
                 [class.invalid]="isFieldInvalid(loginForm, 'username')">
          <small *ngIf="isFieldInvalid(loginForm, 'username')" class="error-text">Requerido</small>
        </div>
        <div class="form-group">
          <label>Contraseña</label>
          <input type="password" formControlName="password" class="form-control"
                 [class.invalid]="isFieldInvalid(loginForm, 'password')">
          <small *ngIf="isFieldInvalid(loginForm, 'password')" class="error-text">Requerido</small>
        </div>

        <div style="text-align: right; margin-bottom: 15px;">
          <a class="toggle-text" style="font-size: 0.8rem; cursor: pointer; color: #666;"
             (click)="setView('forgot-email')">¿Olvidaste tu contraseña?</a>
        </div>

        <button type="submit" [disabled]="loginForm.invalid || isLoading" class="btn-submit">
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? 'Validando...' : 'Iniciar Sesión' }}
        </button>
      </form>

      <div class="toggle-text">
        ¿No tienes cuenta?
        <a (click)="setView('register')">Registrarse</a>
      </div>
    </div>

    <div *ngIf="currentView === 'register'" class="form-container fade-in">
      <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
        <div class="form-group">
          <label>Nombre Completo</label>
          <input type="text" formControlName="fullname" class="form-control"
                 [class.invalid]="isFieldInvalid(registerForm, 'fullname')">
        </div>
        <div class="form-row">
          <div class="form-group half">
            <label>Usuario</label>
            <input type="text" formControlName="username" class="form-control"
                   [class.invalid]="isFieldInvalid(registerForm, 'username')">
          </div>
          <div class="form-group half">
            <label>Fecha Nacimiento</label>
            <input type="date" formControlName="birthDate" class="form-control"
                   [class.invalid]="isFieldInvalid(registerForm, 'birthDate')">
          </div>
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email" formControlName="email" class="form-control"
                 [class.invalid]="isFieldInvalid(registerForm, 'email')"
                 [readonly]="inviteLocked">
          <small *ngIf="isFieldInvalid(registerForm, 'email')" class="error-text">Email inválido</small>
          <small *ngIf="inviteLocked" class="error-text" style="color:#6b7280">Correo de tu ficha (no editable)</small>
        </div>
        <div class="form-row">
          <div class="form-group half">
            <label>Teléfono</label>
            <input type="text" formControlName="telephone" class="form-control"
                   [class.invalid]="isFieldInvalid(registerForm, 'telephone')"
                   [readonly]="inviteLocked">
          </div>
          <div class="form-group half">
            <label>Contraseña</label>
            <input type="password" formControlName="password" class="form-control"
                   [class.invalid]="isFieldInvalid(registerForm, 'password')">
            <small *ngIf="isFieldInvalid(registerForm, 'password')" class="error-text">Mín. 6 caracteres</small>
          </div>
        </div>

        <button type="submit" [disabled]="registerForm.invalid || isLoading" class="btn-submit">
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? 'Registrando...' : 'Registrarse' }}
        </button>
      </form>

      <div class="toggle-text">
        ¿Ya tienes cuenta?
        <a (click)="setView('login')">Inicia Sesión</a>
      </div>
    </div>

    <div *ngIf="currentView === 'forgot-email'" class="form-container fade-in">
      <form [formGroup]="forgotEmailForm" (ngSubmit)="onSendRecoveryEmail()">
        <div class="form-group">
          <label>Ingresa tu Email</label>
          <input type="email" formControlName="email" class="form-control"
                 placeholder="ejemplo@correo.com"
                 [class.invalid]="isFieldInvalid(forgotEmailForm, 'email')">
          <small *ngIf="isFieldInvalid(forgotEmailForm, 'email')" class="error-text">Email requerido</small>
        </div>

        <button type="submit" [disabled]="forgotEmailForm.invalid || isLoading" class="btn-submit">
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? 'Enviando...' : 'Enviar Código' }}
        </button>
      </form>
      <div class="toggle-text">
        <a (click)="setView('login')">Volver al Login</a>
      </div>
    </div>

    <div *ngIf="currentView === 'verify-code'" class="form-container fade-in">
      <form [formGroup]="verifyCodeForm" (ngSubmit)="onVerifyCode()">
        <div class="form-group">
          <label>Código de Verificación</label>
          <input type="text" formControlName="code" class="form-control"
                 placeholder="Ej: 123456" maxlength="6" style="text-align: center; letter-spacing: 5px; font-weight: bold;"
                 [class.invalid]="isFieldInvalid(verifyCodeForm, 'code')">
          <small *ngIf="isFieldInvalid(verifyCodeForm, 'code')" class="error-text">Código de 6 dígitos requerido</small>
        </div>

        <button type="submit" [disabled]="verifyCodeForm.invalid || isLoading" class="btn-submit">
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? 'Verificando...' : 'Verificar Código' }}
        </button>
      </form>

      <div class="toggle-text">
        <span style="font-size: 0.8rem; color: #666;">¿No llegó? </span>
        <a (click)="onResendCode()" style="font-size: 0.8rem;">Reenviar Código</a>
      </div>
      <div class="toggle-text">
        <a (click)="setView('forgot-email')">Cambiar Email</a>
      </div>
    </div>

    <div *ngIf="currentView === 'reset-password'" class="form-container fade-in">
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
        <div class="form-group">
          <label>Nueva Contraseña</label>
          <input type="password" formControlName="newPassword" class="form-control"
                 [class.invalid]="isFieldInvalid(resetPasswordForm, 'newPassword')">
          <small *ngIf="isFieldInvalid(resetPasswordForm, 'newPassword')" class="error-text">Mín. 6 caracteres</small>
        </div>

        <div class="form-group">
          <label>Confirmar Contraseña</label>
          <input type="password" formControlName="confirmPassword" class="form-control">
        </div>

        <button type="submit" [disabled]="resetPasswordForm.invalid || isLoading" class="btn-submit">
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? 'Guardando...' : 'Cambiar Contraseña' }}
        </button>
      </form>
    </div>

  </div>
</div>
